export default __webpack_public_path__ + "static/media/Sellou-dark.ffe1a7e5.png";